export default { // 该需求运行在评估师app > 首页 > 资金额度
  tabs: [
    {
      name: 'CapitalLimit',
      path: '/capitalLimit',
      component: () => import(/* webpackChunkName: "capital-limit" */ './src/CapitalLimit'),
      meta: {
        title: '资金额度',
      }
    }
  ]
}
